import { useRouter } from '@application/utils';
import { StoryPage } from '@presentation/pages';
import { useTranslation } from '@presentation/utils';
import { SeoController } from '../../SeoController';

export const StoryPageController = () => {
  const { routeLocationDescriptor } = useRouter();
  const { translate: translateResource } = useTranslation({ keyPrefix: 'story' });

  return (
    <>
      <SeoController
        title={translateResource('seo.title')}
        description={translateResource('seo.description')}
      />
      <StoryPage joinLink={routeLocationDescriptor('contact')} />
    </>
  );
};
